<!-- eslint-disable vue/this-in-template -->
<template>
  <div
    @click="removeLists"
  >
    <div style="display: flex; justify-content: space-between; width: 100%; border-bottom: 1px solid lightgray;">
      <p style="font-size: 32px; font-weight: bold;">
        {{ $t("TruckHistory") }}
      </p>
      <!-- <div
        style="    display: flex;
        justify-content: center;"
        :disabled="getTruckHistory.length == 0"
      >
        <button
          style="    border: 0;
          width: 48px;
          height: 37px; background: transparent linear-gradient(53deg, #0071AE 0%, #55B94A 100%) 0% 0% no-repeat padding-box; border-radius: 5px; margin-right: 5px"
          :disabled="getTruckHistory.length == 0"
          @click="downloadPDF"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="white"
            class="bi bi-file-earmark-pdf"
            viewBox="0 0 16 16"
          >
            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
            <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
          </svg>
        </button>
      </div> -->
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <div style="display: flex; flex-direction: row">
        <div>
          <div style="display: flex;">
            <div style="margin-top: 20px">
              <div class="black">
                <b-icon-search
                  v-if="searchPlate == ''"
                  class="search1"
                  style="position: absolute; left: 5px; top: 10px"
                />
                <b-icon-x-circle
                  v-else-if="searchPlate != '' && !noSearch"
                  class="search1"
                  style="position: absolute; margin-top: -6px; right: 10px; top: 17px; cursor: pointer"
                  @click="searchPlate = ''"
                />
                <input
                  v-model="searchPlate"
                  type="text"
                  autocomplete="off"
                  name="search-box"
                  :placeholder="$t(`Truck'sPlate`)"
                  :style="
                    getFilterPlateTruck.length > 0 && noSearch
                      ? 'border-radius: 8px 8px 8px 8px'
                      : 'border-radius: 8px 8px 8px 8px; padding-left: 25px;'
                  "
                  @keyup="inputChanged"
                  @keydown.down="onArrowDown"
                  @keydown.up="onArrowUp"
                >
              </div>
              <div
                v-if="getFilterPlateTruck.length > 0 && noSearch"
                ref="scrollContainer"
                class="dropdrop"
                :style="getFilterPlateTruck.length > 7 ? 'height: 210px' : 'height: auto'"
              >
                <div
                  v-for="(result, index) in getFilterPlateTruck"
                  :key="index"
                  ref="options"
                  style="cursor: pointer"
                  class="search-item"
                  :class="{ 'is-active': index === arrowCounter }"
                  @click="
                    noSearch = false;
                    truckk(result.truckId)
                    searchByOn(result.registrationPlate);
                  "
                >
                  <p style="margin: 0">
                    {{ result.registrationPlate }}
                  </p>
                </div>
              </div>
            </div>
            <b-form-group
              id="input-group-9"
              style="margin-left: 15px"
              :label="$t('CalculationDate')"
              label-for="input-9"
            >
              <date-picker
                v-model="time1"
                type="date"
                style="height: 40px"
                value-type="format"
                :placeholder="$t('Select')"
                :format="'DD-MM-YYYY'"
                :lang="lang"
              />
            </b-form-group>
            <b-button
              type="button"
              variant="none"
              style="margin-left: 15px; height: 40px; margin-top: 22px; width: 170px"
              class="buttonSubmit"
              :disabled="this.selectedDate == null || this.time1== null"
              @click="truckHistory"
            >
              {{ $t("CalculationCalculate") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; padding-top: 16px; margin-top: 5px">
      <table
        class="team_table"
        style="width: 100% !important; box-shadow: 0px 7px 20px rgb(40 41 61 / 8%)"
      >
        <thead>
          <tr>
            <th style="padding: 10px; text-align: left;">
              {{ $t("Date") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("ExchangeEmployeesFullName") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("IsDriver") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("IsResponsible") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("PhoneNumber") }}
            </th>
            <th style="padding: 10px; text-align: left;">
              {{ $t("Status") }}
            </th>
            <th style="padding: 10px; text-align: left;" />
          </tr>
        </thead>
        <tbody>
          <!-- getTrucksPagination getTrucksByStore -->
          <tr
            v-for="name in getTruckHistory"
            :key="name.id"
            style="border-bottom: 1px solid #dcdfe6; color: #606266; cursor: pointer; text-align: left;"
            @click="matProps(filiale)"
          >
            <td style="padding: 10px; text-align: left;">
              {{ dateModified(name.date) }}
            </td>
            <td style="padding: 10px; text-align: left;">
              {{ name.fullName }}
            </td>
            <td
              v-if="name.isDriver == true"
              style="padding: 10px"
            >
              <img
                src="../../assets/car-steering-wheel.png"
                alt=""
                style="width: 20px"
              >
            </td>
            <td
              v-else
              style="padding: 10px"
            />
            <td
              v-if="name.isResponsible == true"
              style="padding: 10px"
            >
              <img
                src="../../assets/check.png"
                alt=""
                style="width: 20px"
              >
            </td>
            <td
              v-else
              style="padding: 10px"
            />
            <td style="padding: 10px; text-align: left;">
              {{ name.countryCode }} {{ name.phoneNumber }}
            </td>
            <td
              v-if="name.cancelled == false"
              style="padding: 10px"
            >

              <div style="display: flex; justify-content: center; ">

                <p>
                  Finished
                </p>
              </div>
            </td>
            <td
              v-else
              style="padding: 10px"
            >

              <div style="display: flex; justify-content: space-evenly; width: 50%; text-align: left;">

                <p>Cancelled</p>
              </div>

            </td>
            <td
              v-if="name.cancelled == false"
              style="padding: 10px"
            >

              <div style="display: flex; justify-content: center; ">
                <img
                  src="../../assets/shipped (2) (1).png"
                  alt=""
                  style="width: 20px"
                >
              </div>
            </td>
            <td
              v-else
              style="padding: 10px"
            >

              <div style="display: flex; justify-content: space-evenly; width: 50%; text-align: left;">
                <img
                  src="../../assets/shipped (3).png"
                  alt=""
                  style="width: 20px"
                >
              </div>

            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
  required,
} from 'vuelidate/lib/validators';
// import axios from 'axios'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import XLSX from 'xlsx';
// import FileSaver from 'file-saver';



export default {
  components: {
    DatePicker,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['materialId', 'createOrder'],
  data() {
    return {
      initialId: '',
      store: null,
      destination: 'ALL',
      status: true,
      time1: null,
      formSubmitted: false,
      time2: null,
      statuss: false,
      storeId: null,
      classNameCh: '',
      searchTerm: '',
      idTruck: null,
      rows: [],
      materialObject: {},
      pageM: 1,
      editMat: {},
      selectedDate: moment().format('DD-MM-YYYY'),
      page: 1,
      isactive: true,
      pageSize: 15,
      pageNumber: 1,
      test: null,
      pressed: false,
      noSearch: false,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      searchPlate: '',
      arrowCounter: 0,
      truckId: '',
      exchangeId: '',
      Id: '',
      enterPressed: false,
      storeGLN: null,
      startDate: null,
      endDate: null,
      truck: {
        truckId: '',
        brandName: '',
        modelName: '',
        variantName: '',
        registrationPlate: '',
        firstRegistration: '',
        insuranceExpirationDate: '',
        storeName: '',
      },
      color: {
        mainDressCategoryColorId: '',
        name: '',
      },
      getFiliale: {
        filialeName: 'Mercedes',
        address: 'Sprinter',
        todayRoutes: 'LU-2142131',
        trucks: '12/03/2018',
        totalEmployee: '12/03/2023',
      },
    };
  },
  validations: {
    store: {
      required,
    },
    time1: {
      required,
    },
    time2: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      'getDressColors',
      'getFiliales',
      'getTotalItemsForFiliales',
      'getTotalItemsForFiliales',
      'getCurrentPageForStore',
      'getTrucksPagination',
      'getTrucksByStore',
      'getFilialesForTrucks',
      'getFilterPlateTruck',
      'getTotalItemsForTrucks',
      'getRoutersForTrucks',
      'getExchangeTrucks',
      'getFilialesForRoutes',
      'getFilterPlateExchangeTruck',
      'getTotalItemsForEXTrucks',
      'getFilialeHours',
      'getFiliales',
      'getTruckHistory',
      'getLoggedInUser',
    ]),
    isValidDate() {
      if (!this.time1 || !this.time2) {
        return true; // allow empty dates
      }
      const start = moment(this.time1, 'DD-MM-YYYY HH:mm').toDate();
      const end = moment(this.time2, 'DD-MM-YYYY HH:mm').toDate();
      return start <= end;
    },
    // calculateButtonDisabled() {
    //   return (
    //     this.$v.store.$required
    //     || this.$v.time1.$required
    //     || this.$v.time2.$required
    //   );
    // },
  },
  watch: {
    searchPlate(value) {
      if (value) {
        this.loadFilteredPlateTruck({
          filter: 'ALL',
          registrationPlate: value,
        });
        this.noSearch = true;
      } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
        return;
      } else {
        this.loadFilteredPlateTruck({
          filter: 'ALL',
          registrationPlate: value,
        });
        this.noSearch = true;
      }
      // console.log('pp', this.getFilterPlateTruck)
    },

    store(value) {
      // console.log('vaa', value)
      this.storeGLN = value.storeGLN
    },
    time1(value) {
      // this.startDate = formattedDate
      const res = moment.tz.guess();
      const value2 = moment.utc(value, 'DD-MM-YYYY');
      this.startDate = moment.tz(value2, 'DD-MM-YYYY', res).format('YYYY-MM-DD'); // Note the [Z] added to format
      // this.startDate = this.startDate.replace(/\+/, '%2B');
    },
    time2(value) {
      // const res = moment.tz.guess();
      // const value2 = moment.utc(value, 'DD-MM-yyyyTHH:mm:ss');
      // const formattedDate = moment.tz(value2, 'DD-MM-yyyyTHH:mm:ss', res).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
      // this.endDate = formattedDate

      const res = moment.tz.guess();
      const value2 = moment.utc(value, 'DD-MM-yyyyTHH:mm:ss');
      this.endDate = moment.tz(value2, 'DD-MM-yyyyTHH:mm:ss', res).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // Note the [Z] added to format
      this.endDate = this.endDate.replace(/\+/, '%2B');
    },
    isValidDate(newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.time2 = null;
      }
    },



  },
  mounted() {
    // this.fetchExchangeTrucks();
    // this.fetchFiliale();
    // this.fetchFilialeForExchangeTrucks();
  },
  methods: {
    ...mapActions([
      'addColorToMainDressCategoryById',
      'editColorToMainDressCategoryById',
      'loadDressColorsById',
      'inventoryProductSizeFromColorId',
      'resetProductsByArticleNumber',
      'resetCustomOrders',
      'loadFilialePagination',
      'changeLoadingtoTrue',
      'loadFilteredStoreName',
      'addTruck',
      'loadTrucksPaginationWithoutStore',
      'loadTrucksByStore',
      'loadFilialePaginationForTrucks',
      'loadFilteredPlateTruck',
      'resetFilteredPlate',
      'editTruckById',
      'loadToursForTrucks',
      'deactivateAndActivateTruck',
      'assignTruckStore',
      'assignExchangeFreeRegularTrucks',
      'loadExchangeTrucksByPagination',
      'assignExchangeTruckStore',
      'assignExchangeTruckStoreToPrivateuser',
      'cancelEXTruck',
      'loadFilialePaginationForRoutes',
      'loadFilteredPlateExchangeTruck',
      'resetFilteredPlateExchangeTruck',
      'loadFilialeHours',
      'loadFilialePagination',
      'loadTruckHistory',
    ]),


    downloadPDF() {
      this.loadTruckHistory({
        truckId: this.idTruck,
        date: this.startDate,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getTruckHistory);

          const totalPages = this.getTruckHistory.totalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });
            const footerIcon = 'data:image/png;base64,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'

            const pdfDocument = this.generatePDF(tableContent, footerIcon);
            pdfDocument.save('TruckHistory.pdf');
          });
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    downloadPage() {
      return this.loadTruckHistory({
        truckId: this.idTruck,
        date: this.startDate,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          return this.generateTableContent(this.getTruckHistory);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    generateTableContent(items) {
      // const headers = [`${this.$t('FilialeName')}`, 'GLN', 'Email', 'Phone', 'Street', 'City', 'Country', 'Trucks', 'Manager', 'TeamLeader', 'Co-TeamLeader'];
      const headers = [`${this.$t('Date')}`, `${this.$t('ExchangeEmployeesFullName')}`,
        `${this.$t('IsDriver')}`, `${this.$t('IsResponsible')}`,
        `${this.$t('PhoneNumber')}`, `${this.$t('Status')}`];
      const body = items.map((item) => {
        return [
          this.dateModified(item.date),
          item.fullName,
          item.isDriver ? 'Yes' : 'No',
          item.isResponsible ? 'Yes' : 'No',
          item.phoneNumber,
          item.cancelled ? 'Cancelled' : 'Finished',
        ]
      });

      return { headers, body };
    },
    // generatePDF(tableContent) {
    //   const { headers, body } = tableContent;

    //   // eslint-disable-next-line new-cap
    //   const doc = new jsPDF();
    //   doc.autoTable({
    //     head: [headers],
    //     body,
    //   });

    //   return doc;
    // },
    generatePDF(tableContent, footerIcon) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF();
      // Add the logo to the top left corner of the first page
      const iconWidth = 30; // Adjust the width of the icon as needed
      const iconHeight = 10; // Adjust the height of the icon as needed
      const iconY = 6; // Adjust the vertical position of the icon (top)

      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 21; // Adjust the height as needed
      doc.setFillColor(0, 113, 174); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      // Add the logo image on top of the blue background on the top left
      const iconX = 15; // Adjust the horizontal position of the icon (left)
      doc.addImage(footerIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 16;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 25;
        doc.setFillColor(0, 113, 174); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        const url = 'www.dslogistik.ch';
        const urlX = 30;
        const urlY = doc.internal.pageSize.getHeight() - 7;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'center' });

        // Add address
        const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
        const addressX = 167;
        const addressY = doc.internal.pageSize.getHeight() - 7;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'center' });

        const iconWidthh = 28; // Adjust the width of the icon as needed
        const iconHeightt = 8; // Adjust the height of the icon as needed
        // const iconX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
        // const iconY = doc.internal.pageSize.getHeight() - 35; // Adjust the vertical position of the icon
        const iconXX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
        const iconYY = doc.internal.pageSize.getHeight() - 13; // Adjust the vertical position of the icon

        doc.addImage(footerIcon, 'PNG', iconXX, iconYY, iconWidthh, iconHeightt);


        // Add the address
        const address1 = 'Powered by DigIT';
        const addressX1 = doc.internal.pageSize.getWidth() / 2;
        const addressY1 = doc.internal.pageSize.getHeight() - 1.5;
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0); // Black color
        doc.text(address1, addressX1, addressY1, { align: 'center' });
      };

      const currentTime = `${this.$t('PrintingDate')}: ${moment().format('DD/MM/YYYY, HH:mm:ss')}`;
      const timeX = doc.internal.pageSize.getWidth() / (10 / 9);
      const timeY = 10;
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(currentTime, timeX, timeY, { align: 'right' });

      // Add the title
      const title = `${this.$t('TruckHistory')}`;
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 20; // Adjust the vertical position of the title
      doc.setFontSize(18);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // // Add the author
      // const authorX = 15;
      // const authorY = 30; // Adjust the vertical position of the author
      // const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`;
      // doc.setFontSize(12);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(`${this.$t('Author')}: ${author}`, authorX, authorY);

      const employeeX = 15;
      const employeeY = 27; // Adjust the vertical position of the author
      const employee = `${this.searchPlate} `;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('LicencePlate')}: ${employee}`, employeeX, employeeY);
      // Add the author
      const authorX = 15;
      const authorY = 32; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author')}: ${author}`, authorX, authorY);

      // Add the table
      const tableOptions = {
        startY: authorY + 5, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [0, 113, 174], // Set the background color for the header
          textColor: [255, 255, 255], // Set the text color for the header
        },
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);

      const hrLineY = doc.internal.pageSize.getHeight() - 20;
      const hrLineX1 = 50;
      const hrLineX2 = doc.internal.pageSize.getWidth() - 50;
      doc.setLineWidth(0.5); // Adjust the line thickness as needed
      doc.line(hrLineX1, hrLineY, hrLineX2, hrLineY);

      // const iconWidthh = 30; // Adjust the width of the icon as needed
      // const iconHeightt = 10; // Adjust the height of the icon as needed
      // // const iconX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // // const iconY = doc.internal.pageSize.getHeight() - 35; // Adjust the vertical position of the icon
      // const iconXX = doc.internal.pageSize.getWidth() / 2 - iconWidth / 2;
      // const iconYY = doc.internal.pageSize.getHeight() - 18; // Adjust the vertical position of the icon

      // doc.addImage(footerIcon, 'PNG', iconXX, iconYY, iconWidthh, iconHeightt);

      // // const companyName = 'Ds-Logistik GmbH';
      // // const footerX = doc.internal.pageSize.getWidth() / 2;
      // // const footerY = doc.internal.pageSize.getHeight() - 10;
      // // doc.setFontSize(10);
      // // doc.setTextColor(0, 0, 0); // Black color
      // // doc.text(companyName, footerX, footerY, { align: 'center' });

      // const address = 'Bahnhofstrasse 276, 4563 Gerlafingen, Switzerland';
      // const addressX = doc.internal.pageSize.getWidth() / 2;
      // const addressY = doc.internal.pageSize.getHeight() - 2;
      // doc.setFontSize(8);
      // doc.setTextColor(0, 0, 0); // Black color
      // doc.text(address, addressX, addressY, { align: 'center' });

      return doc;
    },


    async calculateFilialeHours() {
      // this.formSubmitted = true
      // this.$v.store.$touch();
      // if (this.$v.store.$anyError) {
      //   return;
      // }
      // this.$v.tim1.$touch();
      // if (this.$v.tim1.$anyError) {
      //   return;
      // }
      // this.$v.time2.$touch();
      // if (this.$v.time2.$anyError) {
      //   return;
      // }
      try {
        await this.loadFilialeHours({
          storeGLN: this.storeGLN,
          startDate: this.startDate,
          endDate: this.endDate,
        }).then((res) => {
          console.log(res);
        });
      } catch (e) {
        console.log(e);
      }
    },
    truckk(value) {
      this.idTruck = value
    },
    async fetchExchangeTrucks() {
      try {
        await this.loadExchangeTrucksByPagination({
          registrationPlate: null,
          sourceStoreId: null,
          destinationStoreId: null,
          startShift: null,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        }).then((res) => {
          console.log(res);
        });
      } catch (e) {
        console.log(e);
      }
    },
    async truckHistory() {
      try {
        await this.loadTruckHistory({
          truckId: this.idTruck,
          date: this.startDate,
        }).then((res) => {
          console.log(res);
        });
      } catch (e) {
        console.log(e);
      }
    },
    assignExchangeTruck(object) {
      this.assignExchangeTruckStore({
        object,
        successCallback: () => {
          this.loadExchangeTrucksByPagination({
            registrationPlate: null,
            sourceStoreId: null,
            destinationStoreId: null,
            startShift: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },
    calculate() {
      this.pressed = !this.pressed
    },
    assignExchangeTruckToPrivateUser(object) {
      this.assignExchangeTruckStoreToPrivateuser({
        object,
        successCallback: () => {
          this.loadExchangeTrucksByPagination({
            registrationPlate: null,
            sourceStoreId: null,
            destinationStoreId: null,
            startShift: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },
    getRoutesPerTrucks() {
      this.loadToursForTrucks({
        truckId: this.Id,
        startShift: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
      })
    },
    async cancelExchangeTruck(value) {
      // console.log('123', value)
      await this.cancelEXTruck({
        exchangeTruckId: value,
        successCallback: () => {
          this.loadExchangeTrucksByPagination({
            registrationPlate: null,
            sourceStoreId: null,
            destinationStoreId: null,
            startShift: null,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
        },
      })
    },
    getIDTruck(value) {
      this.Id = value
    },
    dateFormat(value) {
      const duration = moment.duration(value);
      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();

      if (days > 1 && hours > 1) {
        return `${days} days, ${hours} hours, and ${minutes} minutes`;
      } if (days == 1 && hours > 1) {
        return `${days} day, ${hours} hours, and ${minutes} minutes`;
      } if (days == 0 && hours > 1) {
        return `${hours} hours and ${minutes} minutes`;
      }
      return `${hours} hour and ${minutes} minutes`;
    },
    dateModified2(xdate) {
      return moment.utc(xdate).format('DD/MM/YYYY - HH-mm');
    },
    getExchangeId(value) {
      this.exchangeId = value
    },
    async loadFreeAssignedFiliales() {
      await this.loadFilialePagination({
        status: this.status,
        pageSize: 2,
        pageNumber: this.pageNumber,
      })
    },
    async fetchFiliale() {
      try {
        //       // this.changeLoadingtoTrue(false);


        await this.loadFilialePagination({
          status: this.status,
          pageSize: 100,
          pageNumber: 1,
        }).then((res) => {
          console.log(res);
          // this.changeLoadingtoTrue(true);
        });
      } catch (e) {
        console.log(e);
        //       // this.changeLoadingtoTrue(false);
      }
    },
    async handleAssignStore(obj) {
      await this.assignTruckStore({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          });
          // this.freeTeamLeaders();
        },
      });
    },
    async filiale() {
      try {
        await this.loadUsersFullNamesById('TeamLeader').then(() => {
          // console.log('eeeee', res);
        });
      } catch (e) {
        console.log(e);
      }
    },
    async fetchFilialeForExchangeTrucks() {
      try {
        //       // this.changeLoadingtoTrue(false);


        await this.loadFilialePaginationForRoutes({
          status: true,
          pageSize: 100,
          pageNumber: this.pageNumber,
        })
      } catch (e) {
        // console.log(e);
        //       // this.changeLoadingtoTrue(false);

      }
    },
    async deactivateTruck(value) {
      // console.log('1235', value)
      try {
        await this.deactivateAndActivateTruck({
          truckId: value.truckId,
          status: value.status,
          successCallback: () => {
            this.loadTrucksPaginationWithoutStore({
              status: this.status,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            });
          // this.freeTeamLeaders();
          },
        }).then((res) => {
          console.log(res);
        });
      } catch (e) {
        console.log(e);
      }
    },
    async activateTruck(value) {
      // console.log('ert', value)
      // console.log(value)
      try {
        await this.deactivateAndActivateTruck({
          truckId: value.truckId,
          status: true,
          successCallback: () => {
            this.loadTrucksPaginationWithoutStore({
              status: this.status,
              pageNumber: this.pageNumber,
              pageSize: this.pageSize,
            });
          // this.freeTeamLeaders();
          },
        }).then((res) => {
          console.log(res);
        });
      } catch (e) {
        console.log(e);
      }
    },



    async addTruckk(obj) {
      await this.addTruck({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          }).then((res) => {
            console.log(res);
          });
        },
      });
    },
    async handleAssignFoliale(obj) {
      await this.assignTeamLeader({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          })
          // this.freeTeamLeaders();
        },
      });
    },

    async editTruck(obj) {
      // console.log('rreew', obj);
      await this.editTruckById({
        object: obj,
        successCallback: () => {
          this.loadTrucksPaginationWithoutStore({
            storeId: null,
            status: this.status,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          });
        },
      });
    },
    async activeF() {
      this.isactive = !this.isactive;
      this.searchUser = '';
      if (!this.isactive) {
        await this.loadTrucksPaginationWithoutStore({
          status: this.statuss,

          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } else {
        await this.loadTrucksPaginationWithoutStore({
          status: this.status,

          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      }
    },

    // statusFalse() {
    //   // eslint-disable-next-line no-unused-expressions
    //   this.statuss = false;
    // },
    openEdit(value) {
      this.truck.truckId = value.truckId;
      this.truck.brandName = value.brandName;
      this.truck.modelName = value.modelName;
      this.truck.variantName = value.variantName;
      this.truck.registrationPlate = value.registrationPlate;
      this.truck.firstRegistration = value.firstRegistration;
      this.truck.insuranceExpirationDate = value.insuranceExpirationDate;
      this.truck.storeName = value.storeName;
    },
    edit(item) {
      this.color.mainDressCategoryColorId = item.mainDressCategoryColorId;
      this.color.name = item.colorName;
      this.$bvModal.show('modal-edit-color');
    },
    toggleBtn(truee) {
      this.sync = truee;
    },
    matProps(color) {
      this.resetProductsByArticleNumber();
      this.$emit('click', color);
      this.classNameCh = color.colorName;
      this.inventoryProductSizeFromColorId(color.mainDressCategoryColorId);
    },
    async getMVbyMeter(page, pageS) {
      // const { data } =
      await this.loadFilialePagination({
        status: this.status,
        pageNumber: page,
        pageSize: pageS,
      });
    },
    nextMeter() {
      if (this.pageM < this.getTotalItemsForFiliales) {
        this.pageM += 1;
        this.getMVbyMeter(this.pageM, this.pageSize);
      }
    },
    prevMeter() {
      if (this.pageM > 1) {
        this.pageM -= 1;
        this.getMVbyMeter(this.pageM, this.pageSize);
      }
    },
    async onSearchM(query) {
      await this.loadFilteredStoreName({
        name: query,
      });
      if (query == '') {
        this.testResetMV();
        this.getMVbyMeter(this.getCurrentPageForStore, this.pageSize);
      }
    },
    onArrowDown(ev) {
      ev.preventDefault();
      if (this.arrowCounter < this.getFilterPlateTruck.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },

    onArrowUp(ev) {
      ev.preventDefault();
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling();
      }
    },

    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true;
        this.searchByOn(this.getFilterPlateTruck[this.arrowCounter].registrationPlate);
        this.removeLists();
        this.arrowCounter = 0;
        setTimeout(() => {
          this.enterPressed = false;
        }, 1000);
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    matPropss(color) {
      this.truckId = color;
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      // console.log(liH);
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    async searchByOn(value) {
      // console.log('vall', value)
      this.searchPlate = value;
      this.noSearch = false;
      await this.loadExchangeTrucksByPagination({
        registrationPlate: value,
        sourceStoreId: null,
        destinationStoreId: null,
        startShift: this.selectedDate,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    removeLists() {
      this.noSearch = false;
      this.resetFilteredPlateExchangeTruck();
    },
    async clearSelection() {
      try {
        //       // this.changeLoadingtoTrue(false);


        await this.loadTrucksPaginationWithoutStore({
          storeId: null,
          status: this.status,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        }).then((res) => {
          console.log(res);
          // this.changeLoadingtoTrue(true);
        });
      } catch (e) {
        console.log(e);
        //       // this.changeLoadingtoTrue(false);
      }
      // this.store = null;
    },
    resetValue() {
      this.$refs.storeSelect.reset();
    },
    dateModified(xdate) {
      // return moment(xdate).format('DD/MM/YYYY - HH:mm');
      return moment(xdate).format('DD/MM/YYYY');
    },
    previousDay() {
      this.selectedDate = moment(this.selectedDate, 'DD-MM-YYYY').subtract(1, 'days').format('DD-MM-YYYY');
    },
    nextDay() {
      this.selectedDate = moment(this.selectedDate, 'DD-MM-YYYY').add(0.5, 'days').format('DD-MM-YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
// just stuff to make the pen not look terrible


h1 {
  margin: 2em 0 0;
  font-size: 2em;
  font-family: helvetica, ariel, sans-serif;
  text-align: left;
}

h2 {
  margin: 1em 0 2em;
  font-size: 1.4em;
  font-family: helvetica, ariel, sans-serif;
  text-align: left;
}

.codepen-wrapper {
  width: 25%;
  margin: 0 37.5%;
}

// this is the stuff you want.

.registration-ui {
  background: linear-gradient(to bottom, #f8d038 0%, #f5ca2e 100%);
  padding: 0.25em 1em 0.25em 1.75em;
  font-weight: bold;
  font-size: 2em;
  border-radius: 5px;
  border: 1px solid #000;
  box-shadow: 1px 1px 1px #ddd;
  position: relative;
  font-family: helvetica, ariel, sans-serif;
}

.registration-ui:before {
  content: "GB";
  display: block;
  width: 30px;
  height: 100%;
  background: #063298;
  position: absolute;
  top: 0;
  border-radius: 5px 0 0 5px;
  color: #f8d038;
  font-size: 0.5em;
  line-height: 85px;
  padding-left: 5px;
}

.registration-ui:after {
  content: "";
  display: block;
  position: absolute;
  top: 7px;
  left: 5px;
  width: 20px;
  height: 20px;
  border-radius: 30px;
  border: 1px dashed #f8d038;
}
span{
  color: black;
}
p{
  color: black;
}
table td{
  color: black;
}
.search-toggle {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.color-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
  input {
    width: 100px;
  }
}
.button {
  margin-bottom: 15px !important;
  width: 195px;
}
.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}
@media screen and (max-width: 1823px) {
  .color-listing__wrapper2 {
    width: 200px;
    button {
      width: 90%;
    }
    .team_table {
      width: 150px !important;
    }
  }
}
@media screen and (max-width: 1400px) {
  .color-listing__wrapper {
    margin-left: 50px;
    width: 150px !important;
    .team_table {
      width: 150px !important;
    }
  }
  .color-listing__wrapper2 {
    margin-left: 10px;
    width: 200px !important;
    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
    .team_table {
      width: 100% !important;
    }
  }
}
@media screen and (max-width: 896px) {
  .color-listing__wrapper {
    margin-left: 0 !important;
    flex-basis: 49%;
  }
}
.color-listing__wrapper {
  .mats-listing {
    margin-top: 0;
  }
  .table__search-input {
    visibility: hidden;
  }
  input {
    width: 100px;
  }
}
.button {
  margin-bottom: 15px !important;
  width: 195px;
}
.mat {
  display: flex;
  justify-content: space-between;
  align-content: center;
  &.active {
    background-color: #e8e8e8;
  }
  div {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  span {
    margin-left: 10px;
    svg {
      font-size: 15px;
    }
  }
}
.team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}

tr:last-child {
  border-bottom: none !important;
}
@media screen and (max-width: 1823px) {
  .color-listing__wrapper2 {
    width: 200px;
    button {
      width: 90%;
    }
    .team_table {
      width: 150px !important;
    }
  }
}
@media screen and (max-width: 1400px) {
  .color-listing__wrapper {
    margin-left: 50px;
    width: 150px !important;
    .team_table {
      width: 150px !important;
    }
  }
  .color-listing__wrapper2 {
    margin-left: 10px;
    width: 200px !important;
    button {
      width: 150px;
      font-size: 13px;
      height: 36px;
    }
    .team_table {
      width: 100% !important;
    }
  }
}
.search1 {
  padding: 0px;
}
.black {
  position: relative;
}
.black input {
  border: none;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
  height: 36px;
}
.dropdrop::-webkit-scrollbar {
  display: none;
}
.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 600;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}
@media screen and (max-width: 896px) {
  .color-listing__wrapper {
    margin-left: 0 !important;
    flex-basis: 49%;
  }
}
.button {
  width: 195px;
}
.addEmployeeButton {
  width: 210px;
}

@media screen and (max-width: 1600px) {
  .scroll {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 1110px) {
  .button {
    margin-right: 10px;
    font-size: 12px;
    height: 36px;
    width: 150px;
  }
}

.dropdrop::-webkit-scrollbar {
  display: none;
}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
  z-index: 3;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.black {
  position: relative;
}

.black input {
  border: none;
  box-shadow: rgb(40 41 61 / 14%) -1px 4px 10px;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 600;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

@media screen and (max-width: 763px) {
  .con {
    flex-wrap: wrap;
  }

  .active-inactive-con {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .button {
    height: auto;
  }
}

.is-active {
  background-color: #dedede;
}
.year {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // margin-left: 15px;
  //   margin-top: -7px;
  button {
    width: 36px !important;
    height: 36px;
    display: flex;
    margin-right: 5px;
    border-radius: 6px !important;
    justify-content: center;
    border: #c3d0dd 1px solid;
    background-color: #e9ecef;
    align-items: center;
  }
  h5 {
    border: #b4b4b4 2px solid;
    border-radius: 6px;
    background-color: whitesmoke;
    width: 40%;
    height: 36px;
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
  }
}
</style>
